import React from "react";

const HiringJourney = () => {
  return (
    <section className="bg-black py-5">
<div class="container-md">
        <div className="header-animation">
          <h3 className="text-white">From Resume to Role – Our Hiring Journey</h3>
          <p>
            Discover the process that connects the right talent with the right opportunity — driven
            by expertise, strategic insight, and a people-first approach to ensure impactful hiring outcomes.
          </p>
        </div>

        <div className="timeline">
          {/* Step 1 */}
          <div className="timeline-step flex-wrap">
            <div className="timeline-step-left">
              <div className="timeline-number num-odd">1</div>
            </div>
            <div className="timeline-dot"></div>
            <div className="line-segment"></div>
            <div className="timeline-step-right">
              <div className="timeline-content">
                <div className="timeline-title">Requirement Discovery</div>
                <div className="timeline-text">
                  We begin by understanding your business goals, team structure, and hiring needs. This helps us
                  define the role, required skills, and ideal candidate profile.
                </div>
              </div>
            </div>
          </div>

          {/* Step 2 */}
          <div className="timeline-step flex-wrap">
            <div className="timeline-step-left">
              <div className="timeline-content">
                <div className="timeline-title">Talent Sourcing</div>
                <div className="timeline-text">
                  Using a mix of internal talent pools, job boards, referrals, and advanced sourcing tools, we identify and attract
                  top talent suited to your specific requirements.
                </div>
              </div>
            </div>
            <div className="timeline-dot"></div>
            <div className="line-segment"></div>
            <div className="timeline-step-right">
              <div className="timeline-number num-even">2</div>
            </div>
          </div>

          {/* Step 3 */}
          <div className="timeline-step flex-wrap">
            <div className="timeline-step-left">
              <div className="timeline-number num-odd">3</div>
            </div>
            <div className="timeline-dot"></div>
            <div className="line-segment"></div>
            <div className="timeline-step-right">
              <div className="timeline-content">
                <div className="timeline-title">Screening & Shortlisting</div>
                <div className="timeline-text">
                  Each candidate is thoroughly screened through resume reviews, skill assessments, and initial interviews. Only the most qualified.
                </div>
              </div>
            </div>
          </div>

          {/* Step 4 */}
          <div className="timeline-step flex-wrap">
            <div className="timeline-step-left">
              <div className="timeline-content">
                <div className="timeline-title">Interview Coordination</div>
                <div className="timeline-text">
                  We schedule and manage interviews between your team and shortlisted candidates, ensuring a smooth and timely communication process.
                </div>
              </div>
            </div>
            <div className="timeline-dot"></div>
            <div className="line-segment"></div>
            <div className="timeline-step-right">
              <div className="timeline-number num-even">4</div>
            </div>
          </div>

          {/* Step 5 */}
          <div className="timeline-step flex-wrap">
            <div className="timeline-step-left">
              <div className="timeline-number num-odd">5</div>
            </div>
            <div className="timeline-dot"></div>
            <div className="line-segment"></div>
            <div className="timeline-step-right">
              <div className="timeline-content">
                <div className="timeline-title">Evaluation & Selection</div>
                <div className="timeline-text">
                  Based on feedback and performance, we assist you in evaluating final candidates and selecting the best fit — both technically and culturally.
                </div>
              </div>
            </div>
          </div>

          {/* Step 6 */}
          <div className="timeline-step flex-wrap">
            <div className="timeline-step-left">
              <div className="timeline-content">
                <div className="timeline-title">Offer Management</div>
                <div className="timeline-text">
                  We help negotiate and manage the offer process, aligning expectations between the candidate and your organization to ensure mutual satisfaction.
                </div>
              </div>
            </div>
            <div className="timeline-dot"></div>
            <div className="line-segment"></div>
            <div className="timeline-step-right">
              <div className="timeline-number num-even">6</div>
            </div>
          </div>

          {/* Step 7 */}
          <div className="timeline-step flex-wrap">
            <div className="timeline-step-left">
              <div className="timeline-number num-odd">7</div>
            </div>
            <div className="timeline-dot"></div>
            <div className="timeline-step-right">
              <div className="timeline-content">
                <div className="timeline-title">Onboarding Support</div>
                <div className="timeline-text">
                  Once hired, we ensure a smooth transition through onboarding assistance and regular follow-ups to confirm successful placement and satisfaction.
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default HiringJourney;
